var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ChipButtons,_vm._l((_setup.contentTypes),function(contentType){return _c(_setup.ChipButton,{key:contentType.key,attrs:{"active":contentType.isActive}},[_c('button',{on:{"click":function($event){$event.preventDefault();return _setup.toggle(contentType.value)}}},[_vm._v(_vm._s(contentType.translation))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }